// package: credits
// file: credits.proto

var credits_pb = require("./credits_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Credits = (function () {
  function Credits() {}
  Credits.serviceName = "credits.Credits";
  return Credits;
}());

Credits.GetBalance = {
  methodName: "GetBalance",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsGetBalanceRequest,
  responseType: credits_pb.CreditsGetBalanceReply
};

Credits.GetCost = {
  methodName: "GetCost",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsGetCostRequest,
  responseType: credits_pb.CreditsGetCostReply
};

Credits.ListPack = {
  methodName: "ListPack",
  service: Credits,
  requestStream: false,
  responseStream: true,
  requestType: credits_pb.CreditsListPackRequest,
  responseType: credits_pb.CreditsListPackReply
};

Credits.ChangeExpiration = {
  methodName: "ChangeExpiration",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsChangeExpirationRequest,
  responseType: credits_pb.CreditsChangeExpirationReply
};

Credits.CreateAlertLowCredit = {
  methodName: "CreateAlertLowCredit",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreateAlertRequest,
  responseType: credits_pb.AlertReply
};

Credits.GetAlertLowCredit = {
  methodName: "GetAlertLowCredit",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.GetAlertRequest,
  responseType: credits_pb.AlertReply
};

Credits.UpdateAlertLowCredit = {
  methodName: "UpdateAlertLowCredit",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreateAlertRequest,
  responseType: credits_pb.AlertReply
};

Credits.DeleteAlertLowCredit = {
  methodName: "DeleteAlertLowCredit",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.GetAlertRequest,
  responseType: credits_pb.AlertDeleteReply
};

Credits.AddPack = {
  methodName: "AddPack",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsAddPackRequest,
  responseType: credits_pb.CreditsAddPackReply
};

Credits.RefundPack = {
  methodName: "RefundPack",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsRefundPackRequest,
  responseType: credits_pb.CreditsRefundPackReply
};

Credits.ExpireAllPack = {
  methodName: "ExpireAllPack",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsExpireAllPackRequest,
  responseType: credits_pb.CreditsExpireAllPackReply
};

Credits.UpdateCost = {
  methodName: "UpdateCost",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsUpdateCostRequest,
  responseType: credits_pb.CreditsUpdateCostReply
};

Credits.Compute = {
  methodName: "Compute",
  service: Credits,
  requestStream: false,
  responseStream: false,
  requestType: credits_pb.CreditsComputeRequest,
  responseType: credits_pb.CreditsComputeReply
};

Credits.GetConsumationByDay = {
  methodName: "GetConsumationByDay",
  service: Credits,
  requestStream: false,
  responseStream: true,
  requestType: credits_pb.CreditsGetConsumationByDayRequest,
  responseType: credits_pb.CreditsGetConsumationByDayReply
};

exports.Credits = Credits;

function CreditsClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

CreditsClient.prototype.getBalance = function getBalance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.GetBalance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.getCost = function getCost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.GetCost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.listPack = function listPack(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Credits.ListPack, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

CreditsClient.prototype.changeExpiration = function changeExpiration(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.ChangeExpiration, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.createAlertLowCredit = function createAlertLowCredit(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.CreateAlertLowCredit, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.getAlertLowCredit = function getAlertLowCredit(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.GetAlertLowCredit, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.updateAlertLowCredit = function updateAlertLowCredit(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.UpdateAlertLowCredit, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.deleteAlertLowCredit = function deleteAlertLowCredit(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.DeleteAlertLowCredit, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.addPack = function addPack(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.AddPack, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.refundPack = function refundPack(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.RefundPack, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.expireAllPack = function expireAllPack(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.ExpireAllPack, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.updateCost = function updateCost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.UpdateCost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.compute = function compute(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Credits.Compute, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CreditsClient.prototype.getConsumationByDay = function getConsumationByDay(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Credits.GetConsumationByDay, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

exports.CreditsClient = CreditsClient;

